export default __webpack_public_path__ + "static/media/intro2.d65ac56d.mp3";